import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const Footer = () => {
    const [investorComplaintPdf, setInvestorComplaintPdf] = useState(null);
    useEffect(() => {
        fetch("https://admin.asiaticstock.in/api/investor-complaint", {
            method: "GET",
            headers: {
                "api-key": "ASSL#2025_@Stock",
            },
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success && response.data?.pdf_url && response.data?.is_active === true) {
                    setInvestorComplaintPdf(response.data.pdf_url);
                } else {
                    setInvestorComplaintPdf(null);
                }
            })

            .catch(() => { });
    }, []);

    // Footer data
    const footerData = {
        companyInfo: {
            logo: "assets/images/new/Logo.png",
            address: "Plot no 38, Road no-A27, DLF Phase-1, Gurugram, Haryana-122002",
            contact: {
                phone: "+0124-2980883, +0124-4383765",
                email: "asiaticstock@gmail.com",
            },
        },
        companyLinks: [
            { label: "Home", path: "/" },
            { label: "About", path: "/about" },
            // { label: "Services", path: "/" },
            { label: "Margins", path: "/margin" },
            { label: "Technology", path: "/technology" },
            { label: "Download", path: "/download" },
            { label: "Key Managerial Person", path: "/assets/pdf/KMP.pdf" },
            {
                label: "Client Collateral Details",
                path: "https://investorhelpline.nseclearing.in/ClientCollateral/welcomeCLUser",
            },
            { label: "Freeze/Block Trading Account", path: "/assets/pdf/Facility-for-voluntary-freezing.pdf" },
            { label: "Smart ODR", path: "https://smartodr.in/login" },
        ],
        otherLinks: [
            { label: "NSE", path: "https://www.nseindia.com/" },
            { label: "BSE", path: "https://www.bseindia.com/" },
            // { label: "NSDL", path: "https://nsdl.co.in/" },
            // { label: "CDSL", path: "https://www.cdslindia.com/" },
            // { label: "RBI", path: "https://www.rbi.org.in/" },
            { label: "SEBI", path: "https://www.sebi.gov.in/" },
            { label: "Public Notice", path: "/notices" },
        ],

        servicesLinks: [
            { label: "Future Option", path: "/future-option" },
            { label: "Mutual Funds", path: "/mutual-fund" },
            { label: "Investment Philosophy", path: "/investment-philosophy" },
            { label: "Bank Account Details", path: "/bank-account-detail" },
            { label: "IPO", path: "/ipo" },
        ],

        resourcesLinks: [
            { label: "Bank Account Details", path: "/bank-account-detail" },
            { label: "Investor Charter - Stock Broker", path: "/investor-charter-stock-broker" },

            { label: "Investor Complaint Details", path: "/investor-complaint" },

            { label: "Investor Grievance", path: "/escalation-matrix" },
            { label: "Disclaimer", path: "/disclaimer" },
            { label: "Privacy Policy", path: "/privacy-policy" },
            { label: "Broker Norm", path: "/broker-norm" },
            { label: "Contact Us", path: "/contact" },
            { label: "Careers", path: "/careers" },
            { label: "Score Portal", path: "https://scores.sebi.gov.in/" },
        ],

        registrationInfo: [
            "<strong>NSDL Evoting Link</strong> - <a href='https://www.evoting.nsdl.com/' target='_blank' rel='noopener noreferrer'>www.evoting.nsdl.com</a>",
            "<strong>CDSL Evoting Link</strong> - <a href='https://www.evotingindia.com/' target='_blank' rel='noopener noreferrer'>www.evotingindia.com</a>",
            "<strong>Asiatic Stock & Securities Ltd</strong>: SEBI Reg No: INZ000166538 | NSE Member ID: 07845 | BSE Member ID: 6904",
        ],
        investorAlerts: [
            "Stock Brokers can accept securities as margin from clients only by way of pledge in the depository system w.e.f. September 01, 2020.",
            [
                "Update your email id and mobile number with your stock broker / depository participant and receive OTP directly from depository on your email id and/or mobile number to create pledge.",
                "Check your securities / MF / bonds in the consolidated account statement issued by NSDL/CDSL every month. Issued in the interest of Investors",
                "'Prevent unauthorised transactions in your account. Update your mobile numbers/email IDs with your stock brokers. Receive information of your transactions directly from Exchange on your mobile/email at the end of the day. Issued in the interest of investors. KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI registered intermediary (broker, DP, Mutual Fund etc.), you need not undergo the same process again when you approach another intermediary.' Dear Investor, if you are subscribing to an IPO, there is no need to issue a cheque. Please write the Bank account number and sign the IPO application form to authorize your bank to make payment in case of allotment. In case of non allotment the funds will remain in your bank account. As a business we don't give stock tips, and have not authorized anyone to trade on behalf of others. If you find anyone claiming to be part of Asiatic Stock & Securities Ltd. and offering such services, please create a ticket here.",
            ],
        ],
    };

    // if (investorComplaintPdf) {
    //     footerData.resourcesLinks.splice(1, 0, { label: "Investor Complaint Details", path: investorComplaintPdf });
    // } else {
    //     footerData.resourcesLinks.splice(1, 0, { label: "No Data Found", path: "#" });
    // }

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__wrapper">
                    {/* Footer Top Section */}
                    <div className="footer__top footer__top--style1 pb-0">
                        <div className="row gy-5 gx-4">
                            {/* Company Links Column */}
                            <div className="col-md-2 col-sm-4">
                                <div className="footer__links">
                                    <div className="footer__links-tittle">
                                        <h6 className="text-dark">Company</h6>
                                    </div>
                                    <div className="footer__links-content">
                                        <ul className="footer__linklist">
                                            {footerData.companyLinks.map((link, index) => (
                                                <li className="footer__linklist-item" key={index}>
                                                    {link.path.endsWith(".pdf") || link.path.startsWith("http") ? (
                                                        <a href={link.path} target="_blank" rel="noopener noreferrer">
                                                            {link.label}
                                                        </a>
                                                    ) : (
                                                        <Link to={link.path}>{link.label}</Link>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Services Links Column */}
                            <div className="col-md-2 col-sm-4 col-6">
                                <div className="footer__links">
                                    <div className="footer__links-tittle">
                                        <h6 className="text-dark">Services</h6>
                                    </div>
                                    <div className="footer__links-content">
                                        <ul className="footer__linklist">
                                            {footerData.servicesLinks.map((link, index) => (
                                                <li className="footer__linklist-item" key={index}>
                                                    <Link to={link.path}>{link.label}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Resources Links Column */}
                            <div className="col-md-3 col-sm-4 col-6">
                                <div className="footer__links">
                                    <div className="footer__links-tittle">
                                        <h6 className="text-dark">Resources</h6>
                                    </div>
                                    <div className="footer__links-content">
                                        <ul className="footer__linklist">
                                            {footerData.resourcesLinks.map((link, index) => (
                                                <li className="footer__linklist-item" key={index}>
                                                    {link.path.endsWith(".pdf") || link.path.startsWith("http") ? (
                                                        <a href={link.path} target="_blank" rel="noopener noreferrer">
                                                            {link.label}
                                                        </a>
                                                    ) : (
                                                        <Link to={link.path}>{link.label}</Link>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Others Links Column */}
                            <div className="col-md-2 col-sm-4">
                                <div className="footer__links">
                                    <div className="footer__links-tittle">
                                        <h6 className="text-dark">Other Links</h6>
                                    </div>
                                    <div className="footer__links-content">
                                        <ul className="footer__linklist">
                                            {footerData.otherLinks.map((link, index) => (
                                                <li className="footer__linklist-item" key={index}>
                                                    {link.path.endsWith(".pdf") || link.path.startsWith("http") ? (
                                                        <a href={link.path} target="_blank" rel="noopener noreferrer">
                                                            {link.label}
                                                        </a>
                                                    ) : (
                                                        <Link to={link.path}>{link.label}</Link>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* Company Info Column */}
                            <div className="col-md-3">
                                <div className="footer__about">
                                    <Link href="#" className="footer__about-logo">
                                        <img src={footerData.companyInfo.logo} alt="Logo" />
                                    </Link>
                                    <p className="footer__about-moto">
                                        <svg
                                            height="20px"
                                            width="20px"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 640 640"
                                        >
                                            <path
                                                fill="#A6BD91"
                                                d="M128 252.6C128 148.4 214 64 320 64C426 64 512 148.4 512 252.6C512 371.9 391.8 514.9 341.6 569.4C329.8 582.2 310.1 582.2 298.3 569.4C248.1 514.9 127.9 371.9 127.9 252.6zM320 320C355.3 320 384 291.3 384 256C384 220.7 355.3 192 320 192C284.7 192 256 220.7 256 256C256 291.3 284.7 320 320 320z"
                                            />
                                        </svg>
                                        {footerData.companyInfo.address}
                                    </p>
                                    <h6 className="text-dark contact-box-text">CONTACT US</h6>

                                    <p>
                                        <svg
                                            height="20px"
                                            width="20px"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 640 640"
                                        >
                                            <path
                                                fill="#A6BD91"
                                                d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z"
                                            />
                                        </svg>
                                        {footerData.companyInfo.contact.phone}
                                    </p>
                                    <p>
                                        <svg
                                            height="20px"
                                            width="20px"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 640 640"
                                        >
                                            <path
                                                fill="#A6BD91"
                                                d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"
                                            />
                                        </svg>
                                        {footerData.companyInfo.contact.email}
                                    </p>
                                </div>
                            </div>

                            {/* Additional Information */}
                            <div>
                                {footerData.registrationInfo.map((info, index) => (
                                    <p key={index} dangerouslySetInnerHTML={{ __html: info }} />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="text-center">
                        <img
                            src="assets/images/new/NSE_logo.svg"
                            alt="NSE Logo"
                            style={{ width: "140px", marginRight: "20px" }}
                        />
                        <img
                            src="assets/images/new/BSE_logo.svg"
                            alt="BSE Logo"
                            style={{ width: "140px", marginRight: "20px" }}
                        />
                        <img
                            src="assets/images/new/SEBI_logo.png"
                            alt="SEBI Logo"
                            style={{ width: "140px", marginRight: "20px" }}
                        />
                    </div>
                    <div className="bg-light mt-3 rounded-3">
                        <div className="container py-3 px-3">
                            <div className="text-center ">
                                <p className="mb-0 d-flex">
                                    <strong style={{ whiteSpace: "nowrap", marginRight: "15px" }}>
                                        Attention Investor :{" "}
                                    </strong>
                                    {/* eslint-disable-next-line jsx-a11y/no-distracting-elements */}
                                    <marquee>
                                        1. Check your securities / MF / bonds in the consolidated account statement
                                        issued by NSDL/CDSL every month. | 2. Prevent unauthorized transactions in your
                                        account. Update your mobile numbers/email IDs with your stockbrokers. Receive
                                        information of your transactions directly from Exchange on your mobile/email at
                                        the end of the day (Issued in the interest of investors). KYC is one time
                                        exercise while dealing in securities markets. Once KYC is done through a SEBI
                                        registered intermediary (broker, DP, Mutual Fund etc.), you need not undergo the
                                        same process again when you approach another intermediary. | 3. No need to issue
                                        cheques by investors while subscribing to the IPO. Just write the bank account
                                        number and sign in the application form to authorize your bank to make the
                                        payment in case of an allotment. There is no need to worry about the refund as
                                        the money remains in the investor's account.
                                    </marquee>
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Footer Bottom Section */}
                    <div className="footer__bottom">
                        <div className="footer__end">
                            <div className="footer__end-copyright">
                                <p className="mb-0">
                                    © 2026. Made By <Link to="#">Asiatic Stock & Securities LTD</Link>
                                </p>
                            </div>
                            <div>
                                <svg
                                    height="30px"
                                    width="30px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 640"
                                >
                                    <path d="M576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 440 146.7 540.8 258.2 568.5L258.2 398.2L205.4 398.2L205.4 320L258.2 320L258.2 286.3C258.2 199.2 297.6 158.8 383.2 158.8C399.4 158.8 427.4 162 438.9 165.2L438.9 236C432.9 235.4 422.4 235 409.3 235C367.3 235 351.1 250.9 351.1 292.2L351.1 320L434.7 320L420.3 398.2L351 398.2L351 574.1C477.8 558.8 576 450.9 576 320z" />
                                </svg>

                                <svg
                                    height="30px"
                                    width="30px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 640"
                                >
                                    <path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM457.1 180L353.3 298.6L475.4 460L379.8 460L305 362.1L219.3 460L171.8 460L282.8 333.1L165.7 180L263.7 180L331.4 269.5L409.6 180L457.1 180zM419.3 431.6L249.4 206.9L221.1 206.9L392.9 431.6L419.3 431.6z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer Shapes */}
        </footer>
    );
};

export default Footer;
